import React, { Component } from "react";
import * as pageData from "./PageData";

var pageLoad;

export default class Safety extends Component {
    constructor(props) {
        super(props);
        this.interceptClick = this.interceptClick.bind(this);
    }

    componentDidMount() {
        this.afterUpdate();
    }

    componentDidUpdate() {
        this.afterUpdate();
    }

    afterUpdate() {
        pageLoad = Date.now();
        this.props.setInterceptClick(this.interceptClick);
    }

    interceptClick(type) {
        if (type === "safe" || type === "unsafe") {
            this.props.next({ response: type, timeInMs: Date.now() - pageLoad});
            return true;
        }

        return false;
    }

    render() {
        const p = this.props;

        const imgPath = `/images/safety/${p.content.img}`;

        const progressStyle = {
            width: `${this.props.index * (100 / pageData.safetyTestPages)}%`
        };

        return (
<div className="test-page-content-inner test-page-safety" >
    <div className="test-content">
        <img alt="" src={imgPath} />
    </div>
    <div className="progress">
        <div className="progress-bar progress-bar-striped" role="progressbar" style={progressStyle} aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" />
    </div>
</div>
    );
        }
}
